// * ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
// *
// * The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
// * and other pending or existing intellectual property rights in India, the United States and other countries. The Program
// * may contain / reference third party or open source components, the rights to which continue to remain with the applicable
// * third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
// * and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
// * form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
// * otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
// * prosecuted to the maximum extent possible under the law.
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from "@angular/router";
@Component({
    selector: 'data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss'],
    standalone: false
})

//use like: <data-table [dataSource]="dataSource" [displayNames]="displayNames" [pageSize]="pageSize"></data-table>

export class DataTableComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @Input() searchValue: String;
  @Input() dataSource;
  @Input() displayNames;
  @Input() pageSize: number;
  @Input() checkBoxRequired: boolean = false;
  @Input() rightAligned = [];
  alignments = {};
  constructor(private router: Router) { }

  dataSourceSize: number;
  // pageSize: number = 10; //default
  pageIndex: number = 0;
  pageSizeOptions = [5, 10, 20];
  displayedColumns;
  displaySelect: boolean = true;
  completeDataSource;
  selection = new SelectionModel<Element>(true, []);

  ngOnInit() {
    this.completeDataSource = new MatTableDataSource<Element>(this.dataSource);
    this.displayedColumns = this.keys(this.displayNames);
    this.setAlignments();
    this.dataSourceSize = this.completeDataSource.data.length;
    this.dataSource = new MatTableDataSource<Element>(this.completeDataSource.data.slice(0, this.pageSize));
  }

  setAlignments() {
    if (Array.isArray(this.displayedColumns) && Array.isArray(this.rightAligned)) {
      this.displayedColumns.forEach((column, index) => {
        if (this.rightAligned.indexOf(column) >= 0) {
          this.alignments[column] = 'right';
        } else {
          this.alignments[column] = 'left';
        }
      });
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.completeDataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.completeDataSource.data.forEach(row => this.selection.select(row));
  }
  goToPriceRequestDetail(col, element): void {

    this.router.navigate(['sample/requestDetail', col]);
  }
  setPageSize(event): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    let startIndex = this.pageSize * this.pageIndex;
    let endIndex = startIndex + this.pageSize;
    if (endIndex > this.dataSourceSize) {
      endIndex = this.dataSourceSize;
    }
    this.dataSource = new MatTableDataSource<Element>(this.completeDataSource.data.slice(startIndex, endIndex));
  }
  keys(displayNames): Array<string> {
    return Object.keys(displayNames);
  }
}


